module.exports = __webpack_public_path__ + "static/app-dev-d75b1951d20d193ece0cd918167b0a7b.jpg";